import { Modal } from 'antd'
import React from 'react'

import { CloseCircleOutlined } from '@ant-design/icons';
import singleUser from "../../assets/Single Player.png";

import userIc from "../../assets/user-profile.svg";
import MailIc from "../../assets/profile-mail.svg";
import LocationIc from "../../assets/profile-location.svg";


function ProfileModal({ isProfileOpen, setIsProfileOpen, userDetails, utilAssets }) {

    console.log("userDetailsddd", userDetails);
    return (
        <>
            <Modal open={isProfileOpen} onCancel={() => { setIsProfileOpen(false) }}
                footer={null}
                closeIcon={false}

                className='token-model'
                width={1000}
                style={{ height: "90dvh" }}
                centered={true}

                maskClosable={false}

            >
                <div className="r-c-c" style={{ width: "100%", }}>
                    <div className='profile-modal-bg'>
                        <img src={utilAssets?.modalBg} className='full-img' style={{}} />
                        <CloseCircleOutlined className='close-profile-ic' onClick={() => setIsProfileOpen(false)} />
                    </div>

                    <div className='profile-content' style={{}}>
                        <div style={{ width: "15%" }}><img className='full-img' src={utilAssets?.singlePlayer} /></div>
                        <div className='r-c-c p-10 m-b-10' style={{ fontSize: "18px", color: "#FFFFFF", backgroundColor: "#49260E", width: "40%", height: "5vh", borderRadius: 6 }}>{userDetails?.name}</div>
                        <div className='r-c-sb p-10 m-b-10' style={{ fontSize: "14px", color: "#FFFFFF", backgroundColor: "#49260E", width: "40%", height: "3vh", borderRadius: 6 }}>{userDetails?.username} <span><img className='full-img' src={userIc} /></span> </div>
                        <div className='r-c-sb p-10 m-b-10' style={{ fontSize: "14px", color: "#FFFFFF", backgroundColor: "#49260E", width: "40%", height: "3vh", borderRadius: 6 }}>{userDetails?.email} <span><img className='full-img' src={MailIc} /></span></div>
                        <div className='r-c-sb p-10 m-b-10' style={{ fontSize: "14px", color: "#FFFFFF", backgroundColor: "#49260E", width: "40%", height: "3vh", borderRadius: 6 }}>{userDetails?.city} <span><img className='full-img' src={LocationIc} /></span> </div>
                    </div>
                </div>
            </Modal >
        </>
    )
}

export default ProfileModal
